import styled from 'styled-components'

export const PricingFormContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
`

export const DefaultPricingStepContainer = styled.div`
    margin-top: 2rem;
    display: flex;
    flex-direction: column;
`

export const SectionContainer = styled.div`
    border: #e2e8f0 solid 1px;
    padding: 1rem;
    gap: 1rem;
    display: flex;
    flex-direction: column;
`

export const SubSectionContainer = styled.div`
    border: #e2e8f0 solid 1px;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    background-color: #f5f5f5;
`

export const IncrementFieldContainer = styled.div`
    display: flex;
    flex-direction: column;
`

export const LabelWheelContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 5px;
`

export const PricingLabel = styled.label`
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    margin-bottom: 1rem;
`
